
        var result = require("!!../../../../node_modules/css-loader/index.js!./pictures-viewer.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/pictures-viewer/pictures-viewer.component.css
// module id = 1428
// module chunks = 0